import { useEffect } from "react";
import { ProductType, CategoryType } from "../../types";
import { fetchJson } from "../../utils";
import { useAppState } from "../../context";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import CardBlock from "../../pages/catalog/CardBlock";
import useWishList from "../../pages/wishlist/useWishList";
import useCart from "../../pages/cart/useCart";
import { PRODUCT_TYPE } from "../../constants";

interface CategoryVideoStoriesProps {
    categories: CategoryType[];
    title?: string;
    limit?: number;
    exclude?: ProductType[];
}

const CategoryVideoStories = ({ categories, title, exclude = [], limit = 9 }: CategoryVideoStoriesProps) => {
    const [products, setProducts] = useAppState<ProductType[]>(`categories-${categories.sort((a, b) => a.id - b.id ).join('-')}-products`, []);
    const { isInWishlist } = useWishList();
    const { findCartItem } = useCart();

    useEffect(() => {
        fetchJson<{data: ProductType[]}>(`/api/catalog?_filter=${JSON.stringify({
            categories, 
            type: PRODUCT_TYPE.CLIP,
            ...(exclude.length > 0 ? {
                id: {
                    operator: 'nin', 
                    value: exclude.map(product => product.id)
                }
            } : {}),
        })}&_limit=${limit}`)
        .then(({json}) => {
            setProducts(json.data);
        });
    }, [categories]);

    if (products.length === 0) return null;

    return (
        <section className="section s-more">
            <div className="inside-wrapper">
                <h2 className="section__title">
                    {title || `More video stories`}
                </h2>
                <Swiper
                    className="s-more__slider slider swiper js_swiper_more"
                    modules={[Navigation]}
                    slidesPerView={1}
                    spaceBetween={0}
                    resistanceRatio={0}
                    watchSlidesProgress={true}
                    loop={true}
                    speed={500}
                    navigation={{
                        prevEl: '.slider__arrow_prev',
                        nextEl: '.slider__arrow_next'
                    }}
                    breakpoints={{
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        }
                    }}
                >
                    {products.map((product) => (
                        <SwiperSlide key={product.id} className="s-more__slide">
                            <CardBlock 
                                {...product} 
                                onWishlist={isInWishlist(product)}
                                inCart={!!findCartItem(product)}
                            />
                        </SwiperSlide>
                    ))}

                    <div className="slider__controls">
                        <button className="slider__arrow slider__arrow_prev"></button>
                        <button className="slider__arrow slider__arrow_next"></button>
                    </div>
                </Swiper>
            </div>
        </section>
    );
}

export default CategoryVideoStories; 